import { StateManager } from '../stateManager';

import { SET_TAGS } from './actions';

export const initialState = {
  tagsList: null,
};

const setTags = (state, action) => {
  let { tags } = action;
  return { ...state, tagsList: { ...state.tagsList, ...tags } };
};

const actions = {
  [SET_TAGS]: setTags,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
